const initState = {

    token: null,
    errore: null,
    sidebar_collapsed: false,
    recovered: false,

};

const authReducer = (state = initState, action) => {



    switch (action.type) {


        case "LOG_USER_OUT":
            return {
                ...state,
                token: null,
                errore: null,
            };


        case "SET_SIDEBAR_COLLAPSED":
            return {
                ...state,
                sidebar_collapsed: action.d,
            };


        case "LOG_USER_IN":
            return {
                ...state,
                errore: null,
                token: action.token
            };

        case "SWITCH_USER":
            return {
                ...initState,
                token: action.token
            };


        case "ERROR_EMAIL_NOT_EXIST":
            return {
                ...state,
                errore: "The e-mail address you entered does not belong to any user.",
            };
        case "ERROR_VERFICATION_CODE":
            return {
                ...state,
                errore: "The code you have entered is incorrect please try again.",
            };

        case "ERROR_PWD_LOGIN":
            return {
                ...state,
                errore: "The password you entered does not match. Please try again",
            };

        case "ERROR_PWD":
            return {
                ...state,
                errore: "The passwords you entered do not match. Please try again.",
            };

        case "ERROR_LOGGIN_IN":
            return {
                ...state,
                errore: "Your account is inactive. Please contact the administrator.",
            };


        case "RESET_LOGIN":
            return {
                ...state,
                errore: null,
                token: null
            };

        default:
            return state;
    }
};

export default authReducer;
